import { __rest } from 'tslib';

const extractDimensionProps = (props) => {
    const { width, height } = props, rest = __rest(props, ["width", "height"]);
    return {
        $width: width,
        $height: height,
        rest,
    };
};

export { extractDimensionProps };
//# sourceMappingURL=extractDimensionProps.js.map
